import React from "react";

export var deepPropsEqual = function(x, y) {
    var xProps, yProps;
    var equal = true;

    if (x === y) {
        return true;
    }

    if (typeof x !== typeof y) {
        return false;
    }

    // Do not compare functions.
    if (typeof x === "function" && typeof y === "function") {
        return true;
    }

    if (
        (typeof x === "boolean" && typeof y === "boolean") ||
        (typeof x === "string" && typeof y === "string") ||
        (typeof x === "number" && typeof y === "number") ||
        (x instanceof Date && y instanceof Date) ||
        (x instanceof RegExp && y instanceof RegExp) ||
        (x instanceof String && y instanceof String) ||
        (x instanceof Number && y instanceof Number)
    ) {
        return x.toString() === y.toString();
    }

    if (x instanceof Array !== y instanceof Array) {
        return false;
    }

    if (x instanceof Array && y instanceof Array) {
        if (x.length !== y.length) {
            return false;
        }

        for (let i = 0; i < x.length; i++) {
            equal = equal && deepPropsEqual(x[i], y[i]);
        }

        return equal;
    }

    if (x instanceof Object !== y instanceof Object) {
        return false;
    }

    if (React.isValidElement(x) !== React.isValidElement(y)) {
        return false;
    }

    if (React.isValidElement(x) && React.isValidElement(y)) {
        return deepPropsEqual(x.props, y.props);
    }

    if (x instanceof Object && y instanceof Object) {
        if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
        }

        if (x.constructor !== y.constructor) {
            return false;
        }

        if (x.prototype !== y.prototype) {
            return false;
        }

        xProps = Object.keys(x);
        yProps = Object.keys(y);

        if (xProps.length !== yProps.length) {
            return false;
        }

        equal = true;
        for (let i = 0; i < xProps.length; i++) {
            if (xProps[i] !== yProps[i]) {
                return false;
            }
            equal = equal && deepPropsEqual(x[xProps[i]], y[yProps[i]]);
        }
        return equal;
    }

    return true;
};
